const MAP = {
  Pending: { label: "In attesa", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  Approved: { label: "Approvato", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  Rejected: { label: "Segnalato", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

export const STATUS_LABELS = { Pending: "In attesa", Approved: "Approvato", Rejected: "Segnalato" };

export const StatusBadge = ({ status, testId }) => {
  const s = MAP[status] || MAP.Pending;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
};
